<template>
  <div
    class="c-tick-flash"
    :class="{
      'cell-flash-green': isPositive && isFullCell,
      'cell-flash-red': isNegative && isFullCell,
      'text-flash-green': isPositive && isTextOnly,
      'text-flash-red': isNegative && isTextOnly
    }"
  >
    <slot>{{ value }}</slot>
  </div>
</template>

<script>
export default {
  name: 'c-tick-flash',
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      isPositive: false,
      isNegative: false,
      timeoutId: null
    };
  },
  computed: {
    isDisabled() {
      return this.$store.state.applicationSettings.general.settings.flashDisplay.flashMode === 'disabled';
    },
    isTextOnly() {
      return (
        ['noanimation', 'textOnly'].includes(
          this.$store.state.applicationSettings.general.settings.flashDisplay.flashMode
        ) && !this.isDisabled
      );
    },
    isFullCell() {
      return (
        this.$store.state.applicationSettings.general.settings.flashDisplay.flashMode === 'fullCell' && !this.isDisabled
      );
    }
  },
  mounted() {
    this.$el.addEventListener('animationend', this.reset);
  },
  watch: {
    value(newValue, oldValue) {
      // stop previous running animation
      this.reset();
      newValue = parseFloat(newValue);
      oldValue = parseFloat(oldValue);
      if (isNaN(oldValue) || isNaN(newValue)) return;
      // start new animation
      this.$nextTick(() => {
        if (oldValue !== '' && oldValue !== null) {
          this.isPositive = newValue > oldValue;
          this.isNegative = !this.isPositive;
        }
      });
    }
  },
  beforeDestroy() {
    this.$el.removeEventListener('animationend', this.reset);
  },
  methods: {
    reset() {
      this.isPositive = this.isNegative = false;
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-tick-flash';
</style>
